import { MenuItem } from "presentation/view/components/OverflowMenuButton";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

import { ConstraintDefEntity } from "domain/entity/Criteria/ConstraintDefEntity";
import { CriteriaEntity } from "domain/entity/Criteria/CriteriaEntity";
import { EMPTY_POOL_EXCL_CRITERIA_ENTITY, EmptyPoolExclCriteriaEntity } from "domain/entity/EmptyPoolExclusion/EmptyPoolExclCriteriaEntity";
import { GroupRadioList } from "veronica-ui-component/dist/component/core/GroupRadioButton/GroupRadioButton";

export interface EmptyExclCriteriaDropdownOptions {

    chargeIndDropdownOptions: DropdownProps[],
    consDefDropdownOptions: DropdownProps[],
    consValueDropdownOptions: { [key: string]: DropdownProps[] },

    opsLineDropdownOptions: DropdownProps[],
    chargeOnCompanyDropdownOptions: DropdownProps[],
    cntrSizeDropdownOptions: DropdownProps[],
    cntrTypeDropdownOptions: DropdownProps[],
    cntrStatusDropdownOptions: DropdownProps[],
    operatingTmlDropdownOptions: DropdownProps[],
    locationTypeDropdownOptions: DropdownProps[],
    opsLineCompanyDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],

}
export interface EmptyExclCriteriaChangeState extends BaseViewChangeSate {
    editingCriteriaEntity: EmptyPoolExclCriteriaEntity,
    allFormState?: { [x: string]: string },
}

export interface EmptyExclCriteriaModel {
    isLoading: boolean,
    isShowDetail: boolean,
    isShowCriteriaPanel: boolean,
    criteriaEntityList: EmptyPoolExclCriteriaEntity[],
    currentSelectedRow: EmptyPoolExclCriteriaEntity,
    selectedRows: CriteriaEntity[],
    dynamicOptions: EmptyExclCriteriaDropdownOptions,
    isRefreshInitData: boolean,
    subMenuItemArray: MenuItem[],
    isShowMoveToPanel: boolean,
    masterState: EmptyExclCriteriaChangeState,
    entrypoint: string,
    consGrpsTypeDropdownOptions: GroupRadioList[],
    allConstraintDef: ConstraintDefEntity[],
}

export const EMPTY_POOL_EXCL_MODEL: EmptyExclCriteriaModel = {
    isLoading: false,
    isShowDetail: false,
    isShowCriteriaPanel: false,
    criteriaEntityList: [],
    currentSelectedRow: { ...EMPTY_POOL_EXCL_CRITERIA_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        chargeIndDropdownOptions: [],
        consDefDropdownOptions: [],
        consValueDropdownOptions: {},

        opsLineDropdownOptions: [],
        chargeOnCompanyDropdownOptions: [],
        cntrSizeDropdownOptions: [],
        cntrTypeDropdownOptions: [],
        cntrStatusDropdownOptions: [],
        operatingTmlDropdownOptions: [],
        locationTypeDropdownOptions: [],
        opsLineCompanyDropdownOptions: [],
        chargeTypeDropdownOptions: [],
    },
    isRefreshInitData: true,
    subMenuItemArray: [],
    isShowMoveToPanel: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        allFormState:{},
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingCriteriaEntity: EMPTY_POOL_EXCL_CRITERIA_ENTITY
    },
    entrypoint: "",
    consGrpsTypeDropdownOptions: [],
    allConstraintDef: [],
}